import { render } from "./FilterSection.vue?vue&type=template&id=3cdac580&scoped=true"
import script from "./FilterSection.vue?vue&type=script&lang=js"
export * from "./FilterSection.vue?vue&type=script&lang=js"

import "./FilterSection.vue?vue&type=style&index=0&id=3cdac580&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/soilfood.com/soilfood.com/vue/oma-myyja/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cdac580"]])

export default __exports__